/* Carrusel de reseñas Smartcret — externalizado desde sections/reviews-carousel.liquid */
(function () {
  function initSmartcretReviews(section) {
    if (section.dataset.smartcretInit) return;
    section.dataset.smartcretInit = 'true';

    var track      = section.querySelector('.smartcret-reviews__track');
    var container  = section.querySelector('.smartcret-reviews__track-container');
    var dotsEl     = section.querySelector('.smartcret-reviews__dots');
    var prevBtn    = section.querySelector('.smartcret-reviews__arrow--prev');
    var nextBtn    = section.querySelector('.smartcret-reviews__arrow--next');
    if (!track || !container || !dotsEl || !prevBtn || !nextBtn) return;
    var cards      = Array.from(track.querySelectorAll('.smartcret-reviews__card-outer'));
    var cpvDesktop = parseInt(section.dataset.cardsPerView, 10) || 3;

    /* ── Botones Ver traducción / Ver original ── */
    cards.forEach(function (card) {
      var toggle = card.querySelector('.smartcret-reviews__toggle');
      if (!toggle) return;
      var textEl = card.querySelector('.smartcret-reviews__review-text');
      var btnT   = card.querySelector('.smartcret-reviews__toggle-btn--translation');
      var btnO   = card.querySelector('.smartcret-reviews__toggle-btn--original');
      var txtT   = textEl.dataset.translated;
      var txtO   = textEl.dataset.original;
      btnT.addEventListener('click', function () {
        textEl.textContent = txtT;
        btnT.classList.add('is-active');
        btnO.classList.remove('is-active');
      });
      btnO.addEventListener('click', function () {
        textEl.textContent = txtO;
        btnO.classList.add('is-active');
        btnT.classList.remove('is-active');
      });
    });

    /* ── Carrusel ── */
    var cur = 0;
    var GAP = 16;
    var cpv = getCPV();

    function getCPV() {
      var w = window.innerWidth;
      if (w < 641) return 1;
      if (w < 960) return 2;
      return cpvDesktop;
    }

    function isMobile() { return window.innerWidth < 641; }

    function total() { return Math.max(0, cards.length - cpv); }

    function setWidths() {
      cpv = getCPV();
      var containerW = container.offsetWidth;
      var peekOffset = isMobile() ? 32 : 0;
      var cw = (containerW - peekOffset - GAP * (cpv - 1)) / cpv;
      cards.forEach(function (c) { c.style.width = cw + 'px'; });
    }

    function cardW() { return cards.length ? (cards[0].offsetWidth + GAP) : 0; }

    function move(instant) {
      if (instant) track.classList.add('no-transition');
      track.style.transform = 'translateX(-' + (cur * cardW()) + 'px)';
      if (instant) {
        track.offsetHeight;
        track.classList.remove('no-transition');
      }
    }

    function dots() {
      dotsEl.innerHTML = '';
      var n = total() + 1;
      if (n <= 1) { dotsEl.style.display = 'none'; return; }
      dotsEl.style.display = 'flex';
      for (var i = 0; i <= total(); i++) {
        (function (idx) {
          var d = document.createElement('button');
          d.className = 'smartcret-reviews__dot' + (idx === cur ? ' smartcret-reviews__dot--active' : '');
          d.setAttribute('aria-label', String(idx + 1));
          d.addEventListener('click', function () { go(idx); stopAutoplay(); startAutoplay(); });
          dotsEl.appendChild(d);
        })(i);
      }
    }

    function syncDots() {
      dotsEl.querySelectorAll('.smartcret-reviews__dot').forEach(function (d, i) {
        d.classList.toggle('smartcret-reviews__dot--active', i === cur);
      });
    }

    function arrows() {
      prevBtn.disabled = cur === 0;
      nextBtn.disabled = cur >= total();
    }

    function go(i) {
      cur = Math.max(0, Math.min(i, total()));
      move(false); syncDots(); arrows();
    }

    prevBtn.addEventListener('click', function () { go(cur - 1); stopAutoplay(); startAutoplay(); });
    nextBtn.addEventListener('click', function () { go(cur + 1); stopAutoplay(); startAutoplay(); });

    /* ── TOUCH — swipe nativo ── */
    var tsx = 0, tsy = 0, tMoved = false;

    track.addEventListener('touchstart', function (e) {
      tsx = e.changedTouches[0].screenX;
      tsy = e.changedTouches[0].screenY;
      tMoved = false;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchmove', function () {
      tMoved = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (tMoved) {
        var dx = tsx - e.changedTouches[0].screenX;
        var dy = tsy - e.changedTouches[0].screenY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          go(cur + (dx > 0 ? 1 : -1));
        }
      }
      startAutoplay();
    }, { passive: true });

    track.addEventListener('touchcancel', startAutoplay, { passive: true });

    /* ── POINTER DRAG — drag con ratón en desktop ── */
    var dragStartX = 0;
    var dragStartCur = 0;
    var isDragging = false;
    var dragMoved = false;

    container.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.smartcret-lb-trigger') ||
          e.target.closest('.smartcret-reviews__toggle-btn')) return;
      isDragging = true;
      dragMoved  = false;
      dragStartX = e.clientX;
      dragStartCur = cur;
      container.classList.add('is-dragging');
      track.classList.add('no-transition');
      container.setPointerCapture(e.pointerId);
      stopAutoplay();
    });

    container.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 5) dragMoved = true;
      var offset = dragStartCur * cardW() - dx;
      var minOff = 0;
      var maxOff = total() * cardW();
      if (offset < minOff) offset = minOff - (minOff - offset) * 0.3;
      if (offset > maxOff) offset = maxOff + (offset - maxOff) * 0.3;
      track.style.transform = 'translateX(-' + offset + 'px)';
    });

    container.addEventListener('pointerup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      container.classList.remove('is-dragging');
      track.classList.remove('no-transition');
      var dx = e.clientX - dragStartX;
      var threshold = cardW() * 0.25;
      if (dragMoved && Math.abs(dx) > threshold) {
        go(dragStartCur + (dx < 0 ? 1 : -1));
      } else {
        go(dragStartCur);
      }
      startAutoplay();
    });

    container.addEventListener('pointercancel', function () {
      if (!isDragging) return;
      isDragging = false;
      container.classList.remove('is-dragging');
      track.classList.remove('no-transition');
      go(dragStartCur);
      startAutoplay();
    });

    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* ── Resize ── */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var p = cpv; setWidths();
        if (p !== cpv) { cur = Math.min(cur, total()); dots(); arrows(); }
        move(true);
      }, 120);
    });

    setWidths(); dots(); arrows(); move(true);

    /* ── AUTOPLAY — avanza cada 3 segundos ── */
    var autoplayTimer;

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        var next = cur + 1;
        if (next > total()) next = 0;
        go(next);
      }, 3000);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    startAutoplay();

    /* ── LIGHTBOX GALERÍA ── */
    var sectionId = section.id.replace('smartcret-reviews-', '');
    var lb = document.getElementById('smartcret-lb-' + sectionId);
    if (!lb) return;
    var lbImg    = lb.querySelector('.smartcret-lb__img');
    var lbClose  = lb.querySelector('.smartcret-lb__close');
    var lbPrev   = lb.querySelector('.smartcret-lb__nav--prev');
    var lbNext   = lb.querySelector('.smartcret-lb__nav--next');
    var lbDotsEl = lb.querySelector('.smartcret-lb__dots');

    var lbGallery = [];
    var lbIndex   = 0;

    function lbShow(idx) {
      lbIndex = Math.max(0, Math.min(idx, lbGallery.length - 1));
      lbImg.src = lbGallery[lbIndex];
      lbImg.style.animation = 'none';
      lbImg.offsetHeight;
      lbImg.style.animation = '';
      lbPrev.disabled = lbIndex === 0;
      lbNext.disabled = lbIndex === lbGallery.length - 1;
      lbDotsEl.querySelectorAll('.smartcret-lb__dot').forEach(function (d, i) {
        d.classList.toggle('smartcret-lb__dot--active', i === lbIndex);
      });
    }

    function buildLbDots() {
      lbDotsEl.innerHTML = '';
      lbGallery.forEach(function (_, i) {
        var d = document.createElement('button');
        d.className = 'smartcret-lb__dot' + (i === lbIndex ? ' smartcret-lb__dot--active' : '');
        d.setAttribute('aria-label', String(i + 1));
        d.addEventListener('click', function () { lbShow(i); });
        lbDotsEl.appendChild(d);
      });
    }

    function openLb(gallery, startIndex) {
      lbGallery = gallery;
      lb.classList.toggle('single', lbGallery.length === 1);
      buildLbDots();
      lbShow(startIndex);
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      stopAutoplay(); /* pausar mientras el lightbox está abierto */
    }

    function closeLb() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      lbImg.src = '';
      lbGallery = [];
      startAutoplay(); /* reanudar al cerrar el lightbox */
    }

    section.querySelectorAll('.smartcret-reviews__images').forEach(function (galleryEl) {
      var raw = galleryEl.dataset.gallery;
      var imgs;
      try { imgs = JSON.parse(raw); } catch (e) { imgs = []; }

      galleryEl.querySelectorAll('.smartcret-lb-trigger').forEach(function (img) {
        img.addEventListener('click', function () {
          if (dragMoved) return;
          var idx = parseInt(img.dataset.index, 10) || 0;
          openLb(imgs, idx);
        });
      });
    });

    lbClose.addEventListener('click', closeLb);
    lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
    lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });

    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeLb();
    });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape')      closeLb();
      if (e.key === 'ArrowLeft')   lbShow(lbIndex - 1);
      if (e.key === 'ArrowRight')  lbShow(lbIndex + 1);
    });

    var lbTsx = 0;
    lb.addEventListener('touchstart', function (e) { lbTsx = e.changedTouches[0].screenX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      var d = lbTsx - e.changedTouches[0].screenX;
      if (Math.abs(d) > 40) lbShow(lbIndex + (d > 0 ? 1 : -1));
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.smartcret-reviews').forEach(initSmartcretReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-inicializar al recargar la sección en el editor de temas */
  document.addEventListener('shopify:section:load', initAll);
})();
